import { render, staticRenderFns } from "./BaseMattersWrapperForm.vue?vue&type=template&id=23083bb8&scoped=true"
import script from "./BaseMattersWrapperForm.vue?vue&type=script&lang=js"
export * from "./BaseMattersWrapperForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=23083bb8&prod&scoped=true&lang=css&external"
import style1 from "./BaseMattersWrapperForm.vue?vue&type=style&index=1&id=23083bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23083bb8",
  null
  
)

export default component.exports